import React, { useState, useRef, useCallback, useEffect } from 'react';
import { connect } from "react-redux";
import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import FormField from '../../../../../../dynamicFormBuilder/FormField';
import { IDCodeDescriptionLookupLayout } from '../../../../../../common/lookups/Layouts/IdLayouts';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { alert } from 'devextreme/ui/dialog';

const ProShipShipmentLayout = [
    {
        groupId: 1,
        label: "",
        fields: [
            {
                name: "SHIPSERVICE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Ship Service",
                type: "lookup",
                layout: IDCodeDescriptionLookupLayout({ codeType: 'PS' }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "SHIPLEVEL",
                tableName: "WMTRANSACTIONHEADER",
                label: "Ship Level",
                type: "select",
                options: [""],
                required: false,
                visible: true,
                searchEnabled: false,
                isLabelChanged: false,
            },
            {
                name: "SHIPACCOUNT",
                tableName: "WMTRANSACTIONHEADER",
                label: "Ship Account",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            }
        ]
    }
];

const ProShipShipment = ({ visible, onClose, oidc, customerId, headerId }) => {
    const [formFields, setFormFields] = useState({
        SHIPSERVICE: null,
        SHIPLEVEL: '',
        SHIPACCOUNT: ''
    });
    const [loading, setLoading] = useState(false);
    const formRefs = useRef({});
    const currentUser = oidc?.user;
    const accessToken = oidc?.user?.access_token;
    const DYNAMICFORMSETTING = oidc?.user?.profile?.DYNAMICFORMSETTING;

    useEffect(() => {
        if (visible && customerId) {
            const fetchDefaults = async () => {
                setLoading(true);
                try {
                    const response = await axios.get(
                        `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/GetProShipShipment`,
                        {
                            params: { customerId },
                            headers: {
                                access_token: accessToken,
                                Authorization: `Bearer ${accessToken}`
                            }
                        }
                    );
                    const data = response?.data || {};
                    setFormFields({
                        SHIPSERVICE: data.shipServiceCode || data.ShipServiceCode || null,
                        SHIPLEVEL: data.shipServiceLevel || data.ShipServiceLevel || '',
                        SHIPACCOUNT: data.shipAccount || data.ShipAccount || ''
                    });
                } catch (err) {
                    console.error('Error fetching ProShip defaults:', err);
                } finally {
                    setLoading(false);
                }
            };
            fetchDefaults();
        }
    }, [visible, customerId, accessToken]);

    const handleFieldChange = useCallback(() => {
    }, []);

    const handleFormLoad = useCallback(() => {
        if (formRefs.current['SHIPLEVEL']) {
            const shipLevelOptions = [
                { id: 'A', name: 'Autodetect' },
                { id: 'B', name: 'Crate' },
                { id: 'C', name: 'Serialnumber' },
                { id: 'D', name: 'Sublot' }
            ];
            formRefs.current['SHIPLEVEL'].instance().option('dataSource', shipLevelOptions);
            formRefs.current['SHIPLEVEL'].instance().option('valueExpr', 'id');
            formRefs.current['SHIPLEVEL'].instance().option('displayExpr', 'name');
        }
    }, []);

    const handleClose = () => {
        setFormFields({ SHIPSERVICE: null, SHIPLEVEL: '', SHIPACCOUNT: '' });
        if (onClose) onClose();
    };

    const handleOk = async () => {
        if (!headerId) {
            alert("No transaction selected.", "Warning");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                HeaderId: headerId,
                ShipServiceCode: formFields.SHIPSERVICE,
                ShipServiceLevel: formFields.SHIPLEVEL,
                ShipAccount: formFields.SHIPACCOUNT
            };
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/OpenProShipShipment`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            const result = response?.data || {};
            if (result.success) {
                notify(result.message || "ProShip shipment opened successfully.", "success", 3000);
                handleClose();
            } else {
                alert(result.message || "Error opening ProShip shipment.", "Error");
            }
        } catch (error) {
            console.error('Error opening ProShip shipment:', error);
            alert(error?.response?.data?.message || error?.response?.data || "Error opening ProShip shipment.", "Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Popup
            visible={visible}
            onHiding={handleClose}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title="WM ProShip Parameters"
            width={520}
            height={350}
        >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <style>{`
                .proship-shipment-form .flex-container { display: flex !important; flex-direction: column !important; gap: 12px; width: 100%; }
                .proship-shipment-form .flex-container > * { flex: 1 1 100% !important; max-width: 100% !important; width: 100% !important; }
                .proship-shipment-form .dx-textbox,
                .proship-shipment-form .dx-dropdowneditor,
                .proship-shipment-form .dx-selectbox { width: 100% !important; }
            `}</style>
            <div className="proship-shipment-form" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{ flex: 1, padding: '20px', overflow: 'auto' }}>
                    <FormField
                        currrentUser={currentUser}
                        layoutId='5B5DE8E3-BC98-44E8-959D-95024AA2EA79'
                        layoutName='ProShipShipmentForm'
                        defaultFormSchema={ProShipShipmentLayout}
                        formFields={formFields}
                        setformFields={setFormFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handleFormLoad}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px', borderTop: '1px solid #eee' }}>
                    <Button text="Ok" type="default" icon="check" onClick={handleOk} />
                    <Button text="Cancel" type="normal" icon="close" onClick={handleClose} />
                </div>
            </div>
        </Popup>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ProShipShipment);
